var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#7236CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25C17.8166 9.93019 17.2043 8.70727 16.2575 7.76965C15.3107 6.83202 14.0818 6.23171 12.7603 6.06119C11.4387 5.89066 10.0977 6.15939 8.9439 6.82596C7.79009 7.49253 6.88744 8.51998 6.375 9.75002M6 6.75002V9.75002H9M6 12.75C6.18342 14.0699 6.7957 15.2928 7.74252 16.2304C8.68934 17.168 9.91818 17.7683 11.2397 17.9389C12.5613 18.1094 13.9023 17.8407 15.0561 17.1741C16.2099 16.5075 17.1126 15.4801 17.625 14.25M18 17.25V14.25H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.dbe3aa5b6644207f846764bf3d8f41d7.svg";
export { ForwardRef as ReactComponent };